import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import GroupsIcon from '@mui/icons-material/Groups';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ApartmentIcon from '@mui/icons-material/Apartment';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import BusinessIcon from '@mui/icons-material/Business';
import DescriptionIcon from '@mui/icons-material/Description';
import WorkIcon from '@mui/icons-material/Work';
import BarChartIcon from '@mui/icons-material/BarChart';
import ChecklistIcon from '@mui/icons-material/Checklist';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import { SCREENS, ACTIONS } from './permissions';
import GavelIcon from '@mui/icons-material/Gavel';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CalculateIcon from '@mui/icons-material/Calculate';
import RuleIcon from '@mui/icons-material/Rule';
import PaymentsIcon from '@mui/icons-material/Payments';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';

export const NAVIGATION_ITEMS = [
  {
    key: 'dashboard',
    labelKey: 'navigation.dashboard',
    icon: DashboardIcon,
    path: '/',
    active: true,
    color: 'primary',
    requiresPermission: false,
  },
  {
    key: 'company-management',
    labelKey: 'navigation.companyManagement',
    icon: ApartmentIcon,
    active: false,
    color: 'primary',
    subItems: [
      {
        key: 'companies',
        labelKey: 'navigation.companies',
        path: '/companies',
        icon: BusinessIcon,
        requiresPermission: true,
        screen: SCREENS.COMPANIES,
        action: ACTIONS.VIEW,
      },
      {
        key: 'users',
        labelKey: 'navigation.users',
        path: '/users',
        icon: PeopleIcon,
        requiresPermission: true,
        screen: SCREENS.USERS,
        action: ACTIONS.VIEW,
      },
      {
        key: 'groups',
        labelKey: 'navigation.groups',
        path: '/groups',
        icon: AccountTreeIcon,
        requiresPermission: true,
        screen: SCREENS.GROUPS,
        action: ACTIONS.VIEW,
      },
      {
        key: 'teams',
        labelKey: 'navigation.teams',
        path: '/teams',
        icon: GroupsIcon,
        requiresPermission: true,
        screen: SCREENS.TEAMS,
        action: ACTIONS.VIEW,
      },
    ],
  },
  {
    key: 'firm-management',
    labelKey: 'navigation.firmManagement',
    icon: BusinessCenterIcon,
    active: false,
    color: 'warning',
    subItems: [
      {
        key: 'firms',
        labelKey: 'navigation.firms',
        path: '/firm-management',
        icon: BusinessIcon,
        requiresPermission: true,
        screen: SCREENS.FIRM_MANAGEMENTS,
        action: ACTIONS.VIEW,
      },
      {
        key: 'contracts',
        labelKey: 'navigation.contracts',
        path: '/contracts',
        icon: DescriptionIcon,
        requiresPermission: true,
        screen: SCREENS.CONTRACTS,
        action: ACTIONS.VIEW,
      },
      {
        key: 'offers',
        labelKey: 'navigation.offers',
        path: '/offers',
        icon: GavelIcon,
        requiresPermission: true,
        screen: SCREENS.OFFERS,
        action: ACTIONS.VIEW,
      },
    ],
  },
  {
    key: 'job-management',
    labelKey: 'navigation.jobManagement',
    icon: WorkIcon,
    active: false,
    color: 'success',
    subItems: [
      {
        key: 'jobs',
        labelKey: 'navigation.jobs',
        path: '/job-management',
        icon: AssignmentIcon,
        requiresPermission: true,
        screen: SCREENS.JOB_MANAGEMENT,
        action: ACTIONS.VIEW,
      },
      {
        key: 'tasks',
        labelKey: 'navigation.tasks',
        path: '/tasks',
        icon: ChecklistIcon,
        requiresPermission: true,
        screen: SCREENS.TASKS,
        action: ACTIONS.VIEW,
      },
      {
        key: 'jobAssignments',
        labelKey: 'navigation.jobAssignments',
        path: '/job-assignments',
        icon: GroupWorkIcon,
        requiresPermission: true,
        screen: SCREENS.JOB_ASSIGNMENTS,
        action: ACTIONS.VIEW,
      },
      {
        key: 'jobDistributions',
        labelKey: 'navigation.jobDistributions',
        path: '/is-dagilimlari',
        icon: BarChartIcon,
        requiresPermission: true,
        screen: SCREENS.JOB_DISTRIBUTIONS,
        action: ACTIONS.VIEW,
      },
    ]
  },
  {
    key: 'report-management',
    labelKey: 'navigation.reportManagement',
    icon: AssessmentIcon,
    active: false,
    color: 'error',
    subItems: [
      {
        key: 'reportList',
        labelKey: 'navigation.reportList',
        path: '/report-management',
        icon: AssignmentIcon,
        requiresPermission: true,
        screen: SCREENS.REPORT_MANAGEMENT,
        action: ACTIONS.VIEW,
      },
      {
        key: 'reportFlows',
        labelKey: 'navigation.reportFlows',
        path: '/report-management/flows',
        icon: ViewKanbanIcon,
        requiresPermission: true,
        screen: SCREENS.REPORT_MANAGEMENT,
        action: ACTIONS.VIEW,
      },
    ]
  },
  {
    key: 'invoice-management',
    labelKey: 'navigation.invoiceManagement',
    icon: AccountBalanceWalletIcon,
    // Parent'ın da yetki kontrolü olsun: yetkisi olmayan kullanıcılarda hiç
    // görünmesin. Ayrıca path ekledik — tek alt menü ile aynı path olduğu
    // için doğrudan tıklamada navigate edilebilir (accordion ile aynı sonuç).
    path: '/invoice-management',
    active: false,
    color: 'info',
    requiresPermission: true,
    screen: SCREENS.INVOICE_MANAGEMENT,
    action: ACTIONS.VIEW,
    subItems: [
      {
        key: 'invoices',
        labelKey: 'navigation.invoices',
        path: '/invoice-management',
        icon: ReceiptLongIcon,
        requiresPermission: true,
        screen: SCREENS.INVOICE_MANAGEMENT,
        action: ACTIONS.VIEW,
      },
    ],
  },
  {
    key: 'prim-management',
    labelKey: 'navigation.primManagement',
    icon: EmojiEventsIcon,
    active: false,
    color: 'success',
    subItems: [
      {
        key: 'ciroEkle',
        labelKey: 'navigation.ciroEkle',
        path: '/ciro-ekle',
        icon: AttachMoneyIcon,
        requiresPermission: false,
      },
      {
        key: 'ciroAktar',
        labelKey: 'navigation.ciroAktar',
        path: '/ciro-aktar',
        icon: SwapHorizIcon,
        requiresPermission: false,
        // Sadece yonetim ve ekip liderleri ciro aktarabilir; TEAM_MEMBER goremez.
        rolesAllowed: ['ROOT', 'DIRECTOR', 'TEAM_MANAGER'],
      },
      {
        key: 'primCiroKurallari',
        labelKey: 'navigation.primCiroKurallari',
        path: '/ciro-kurallari',
        icon: CalculateIcon,
        requiresPermission: true,
        screen: SCREENS.PRIM_MANAGEMENT,
        action: ACTIONS.VIEW,
        rolesAllowed: ['ROOT'],
      },
      {
        key: 'primKurallari',
        labelKey: 'navigation.primKurallari',
        path: '/kurallar',
        icon: RuleIcon,
        requiresPermission: true,
        screen: SCREENS.PRIM_MANAGEMENT,
        action: ACTIONS.VIEW,
                rolesAllowed: ['ROOT'],
      },
      {
        key: 'primTahsilat',
        labelKey: 'navigation.primTahsilat',
        path: '/tahsilat',
        icon: PaymentsIcon,
        requiresPermission: true,
        screen: SCREENS.PRIM_MANAGEMENT,
        action: ACTIONS.VIEW,
        rolesAllowed: ['ROOT'],
      },
      {
        key: 'bonusTargets',
        labelKey: 'navigation.bonusTargets',
        path: '/hedefler',
        icon: TrackChangesIcon,
        requiresPermission: true,
        screen: SCREENS.PRIM_MANAGEMENT,
        action: ACTIONS.VIEW,
        rolesAllowed: ['ROOT'],
      },
    ],
  },
  {
    key: 'document-bank',
    labelKey: 'navigation.documentBank',
    icon: FolderCopyIcon,
    path: '/document-bank',
    active: false,
    color: 'info',
    requiresPermission: false,
  },
  {
    key: 'applications',
    labelKey: 'navigation.applications',
    icon: AssignmentIcon,
    path: '/applications',
    active: false,
    color: 'primary',
    subItems: [],
  },
];

export const FOOTER_NAVIGATION_ITEMS = [
  {
    key: 'alerts',
    labelKey: 'navigation.alerts',
    icon: NotificationsIcon,
    path: '/alerts',
    active: false,
    requiresPermission: false,
  },
  {
    key: 'settings',
    labelKey: 'navigation.settings',
    icon: SettingsIcon,
    path: '/settings',
    active: false,
    requiresPermission: true,
    screen: SCREENS.SETTINGS,
    action: ACTIONS.VIEW,
  },
  {
    key: 'logout',
    labelKey: 'navigation.logout',
    icon: LogoutIcon,
    action: 'logout',
    active: false,
    requiresPermission: false,
  },
];

/**
 * Get filtered navigation items based on user permissions
 * @param {Function} hasPermission - Permission check function
 * @returns {Array} Filtered navigation items
 */
export const getAccessibleNavigationItems = (hasPermission, userRole = null) => {
  // rolesAllowed: opsiyonel bir array. Eğer set'li ise yalnızca o rollerdeki
  // kullanıcılara item görünür (permission'a ek bir kısıt). userRole verilmezse
  // role bazlı filter devre dışı (geri uyumluluk için).
  const passesRoleCheck = (entry) => {
    if (!entry.rolesAllowed || !Array.isArray(entry.rolesAllowed) || entry.rolesAllowed.length === 0) {
      return true;
    }
    if (!userRole) return false;
    return entry.rolesAllowed.includes(userRole);
  };

  // SubItems'ı role+permission'a göre filtrele. Boşa düşerse `subItems` key'ini
  // sil (in-place) — SidebarContent'in click handler'ı `else if (item.subItems)`
  // üzerinden accordion'a giriyor; boş array bırakmak applications gibi
  // path'i de olan bir item'ı tıklanamaz hale getirir.
  const filterSubItems = (item) => {
    if (!item.subItems) return;
    const filtered = item.subItems.filter((subItem) => {
      if (!passesRoleCheck(subItem)) return false;
      if (!subItem.requiresPermission) return true;
      return hasPermission(subItem.screen, subItem.action);
    });
    if (filtered.length === 0) {
      delete item.subItems;
    } else {
      item.subItems = filtered;
    }
  };

  return NAVIGATION_ITEMS.filter(item => {
    if (!passesRoleCheck(item)) return false;
    if (!item.requiresPermission) {
      filterSubItems(item);
      return true;
    }

    const hasAccess = hasPermission(item.screen, item.action);

    if (hasAccess) {
      filterSubItems(item);
    }

    return hasAccess;
  });
};

/**
 * Get filtered footer navigation items based on user permissions
 * @param {Function} hasPermission - Permission check function
 * @returns {Array} Filtered footer navigation items
 */
export const getAccessibleFooterNavigationItems = hasPermission => {
  return FOOTER_NAVIGATION_ITEMS.filter(item => {
    if (!item.requiresPermission) return true;
    return hasPermission(item.screen, item.action);
  });
};
